import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { eq } from 'ember-truth-helpers';
import GeneralCountryFlag from 'lumen/components/general/country-flag';
import dayjsFormat from 'lumen/helpers/dayjs-format';

interface HotelOverviewDashboardTilesMarketTrendsEventsTooltipSignature {
  Args: {
    dateFormat: unknown;
    dayData: unknown;
  };
}

const HotelOverviewDashboardTilesMarketTrendsEventsTooltip = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <EmberTooltip
    @tooltipClass="default-tooltip default-tooltip--no-max-width default-table-tooltip card-tile__tooltip--od-events"
  >
    <PrismTooltipHeader>
      <span class="mr-200 ml-200">
        {{dayjsFormat @dayData.fromDateData.fromDate format=@dateFormat}}
      </span>
    </PrismTooltipHeader>
    <table class="default-table">
      <tbody>
        {{#each @dayData.fromDateData.kpis.events as |event|}}
          <tr>
            <td>
              <div class="flex flex-row">
                <div class="flex items-center">
                  {{#if (eq event.type "holiday")}}
                    {{#each event.countries as |countryCode|}}
                      <span class="mr-100">
                        <GeneralCountryFlag @countryCode={{countryCode}} />
                      </span>
                    {{/each}}
                  {{else}}
                    <span class="mr-100">
                      <PrismIcon @name="calendar-accepted" @size="small" />
                    </span>
                  {{/if}}
                  {{event.title}}
                </div>
              </div>
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </EmberTooltip>
</template> satisfies TOC<HotelOverviewDashboardTilesMarketTrendsEventsTooltipSignature>;

export default HotelOverviewDashboardTilesMarketTrendsEventsTooltip;
